import React, {useContext, useEffect, useState} from "react";
import HeaderMenu from "../../../components/Header";
import Sidebar from "../../../components/NavBar";
/* import  Footer  from "../../../components/Footer";
 */ import {
  Layout,
  Row,
  Col,
  Divider,
  List,
  Typography,
  Table,
  Tag,
  Space,
  Form,
  Checkbox,
  Button,
  Input,
  Image,
  Select,
  Modal,
} from "antd";
import { Container, Grid } from "semantic-ui-react";
import { LeftOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditFormEvaluacionCriteriosModel from "./EditFormEvaluacionCriteriosModel";
import "../../../App.scss";
import axios from "axios";
import apiJurados from "../../../api/Jurados/api-jurados";
import { openNotification } from "../../../utils/Notifactions";
import { useMaestras } from "../../../hooks/useMaestras";
import {TemplateContext} from "../../../utils/template_context";
//import { json } from 'stream/consumers';
export default function EvaluacionCriteriosModel(props: any) {
  const { editAssignedCat, setEditAssignedCat, editValue, setEditValue, setEditValueList } = props;

  const { Content } = Layout;
  const { Option } = Select;

  const [evaluationData, setEvaluationData] = useState<any>([]);
  const [evaluationFormData, setEvaluationFormData] = useState<any>({
    idconvocatorias: 1,
    nombre: "",
    descripcion: "",
    porcentaje: "",
  });
  const [editForm, setEditForm] = useState<any>(false);
  const [editFormData, setEditFormData] = useState<any>({});

  const { criterios, obtenerCriterios } = useMaestras()


  const context = useContext(TemplateContext);
  useEffect(() => {
    console.log("editAssignedCat: cccc", editAssignedCat);
    obtenerCriterios();
    if (editAssignedCat) {
      consultarCriterios();
    }
    // setEvaluationData([...editAssignedCat?.arrayData]);
  }, [props]);

  const consultarCriterios = async () => {

    let proyectosAsignados: any = localStorage.proyectosAsignados
    proyectosAsignados = JSON.parse(proyectosAsignados);
    
    // let data = await axios.get(
    //   `${process.env.REACT_APP_SERVER_JURA2}criterios/obtenerCriteriosJuradoPostulacion/${editAssignedCat.id_jurado}/${proyectosAsignados[0].id_postulacion}`
    // );
    const {data} = await apiJurados.obtenerCriteriosJuradoPostulacion(editAssignedCat.id_jurado, proyectosAsignados[0].id_postulacion)


    // if (data.data.constructor.name === "Array") {
    //   return setEvaluationData([...data.data]);
    // }
    return setEvaluationData(data);
  };
  useEffect(() => { }, [evaluationData]);

  const columnsEdit: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 30,
      fixed: context.device === "md"? "left": false,
      render: (datos: any, record: any, index: any) => <div>{index + 1}</div>
    },
    {
      title: <span className="as_tbl_hd">Criterio</span>,
      width: 200,
      dataIndex: "nombre",
      key: "nombre",
      fixed: context.device === "md"? "left": false,
    },
    {
      title: <span className="as_tbl_hd">Descripción</span>,
      width: 100,
      dataIndex: "descripcion",
      key: "descripcion",
      fixed: context.device === "md"? "left": false,
    },
    {
      title: <span className="as_tbl_hd">% evaluación</span>,
      width: 100,
      dataIndex: "porcentaje",
      key: "porcentaje",
      fixed: context.device === "md"? "left": false,
    },
    {
      title: () => (
        <p className="text-center">
          <span className="as_tbl_hd">Acciones</span>
        </p>
      ),
      width: 60,
      fixed: context.device === "lg"? "right": false,
      render: (datos: any, datos2: any, index: any) => (
        <>
          <p className="text-center">
            <a onClick={() => (handelSetArrayData(), setEditForm(true), setEditFormData(datos2))}>
              <EditOutlined />
            </a>
            {"  "}
            <a className="text-danger" onClick={() => onDelete(index, datos2)}>
              <DeleteOutlined style={{ color: "red" }} />
            </a>
          </p>
        </>
      ),
    },
  ];

  function handelSetArrayData() {
    let arrData = [...evaluationData];
    let fullarr = [...editValue];

    editValue.map((item: any, index: any) => {
      if (item.idconvocatorias == editAssignedCat.idconvocatorias) {
        fullarr[index].arrayData = arrData;
      }
    });
    setEditValue(fullarr);
    // setEditValueList(fullarr);
  }

  async function onDelete(params: any, item: any) {
    
    const array = [...evaluationData];
    array.length > 0 && array.splice(params, 1);
    array.length > 0 ? setEvaluationData([...array]) : setEvaluationData([]);
    let data = await axios.delete(
      `${process.env.REACT_APP_SERVER_JURA2}criterios/eliminarCriterio/${item.id}`
    );

    // const mainIndex = editValue.findIndex((item: any) => item.id == editAssignedCat.arrayData[0].id);
    // editValue[mainIndex].arrayData = array;
    setEditValue([...editValue]);
    // const mainArray = editValue.find((item: any) => (item.idco nvocatorias == editAssignedCat.idconvocatorias))
    // const mainIndex = editValue.findIndex((item: any) => (item.idconvocatorias == editAssignedCat.idconvocatorias))
    // mainArray.arrayData?.length>0 && mainArray.arrayData.splice(params, 1);
    // console.log('index:2 ', mainArray);
    // editValue[mainIndex] =mainArray
    // setEditValue([...editValue])
    // mainArray.arrayData?.length>0? setEvaluationData([...editValue.arrayData]):setEvaluationData([])
    // mainArray.arrayData?.length>0&&setEditValue([...mainArray])
    //mainArray.arrayData?.length>0&& setEvaluationData([...mainArray])
  }

  function handelFormSubmit() {
    
    let existeCriterio = evaluationData.find((x: any) => x.nombre === evaluationFormData.nombre);
    if (existeCriterio) {
      return openNotification({
        titulo: "Error",
        descripcion: "Ya se asignó ese criterio",
        placement: "bottomRight",
      });
    }

    let criteriosSin = evaluationData.filter((x: any) => x.nombre !== evaluationFormData.nombre);

    let suma = 0;
    criteriosSin.forEach((x: any) => {
      suma += Number(x.porcentaje);
    });

    let OtraSuma = suma + Number(evaluationFormData.porcentaje);
    if (OtraSuma > 100) {
      return openNotification({
        titulo: "Error",
        descripcion: "No debe superar 100 puntos el puntaje",
        placement: "bottomRight",
      });
    }


    let arrData = evaluationData;
    setEvaluationData([...arrData, evaluationFormData]);

    setEvaluationFormData({
      idconvocatorias: evaluationFormData.idconvocatorias + 1,
      criterio: "",
      descripcion: "",
      porcentaje: "",
    });
  }
  /*   function handelListDataSubmit() {
          let arrData = [...evaluationData];
          console.log('arrData: ', arrData);
         
          editValue.map((item: any, index: any) => {
              if (item.idconvocatorias == editAssignedCat.idconvocatorias) {
                  editValue[index].arrayData = arrData
              }
          })
          props.setIsModalVisible(false)
      } */

  let indexJurado = 0;
  let indexTabla = 0;
  async function handelListDataSubmit() {
    
    let arrData = [...evaluationData];
    let fullarr = [...editValue];

    console.log("Arr Data: ", arrData);
    console.log("Full Data: ", fullarr);
    

    editValue.map((item: any, index: any) => {
      
      if (item.idconvocatorias == editAssignedCat.idconvocatorias) {
        fullarr[index].arrayData = arrData;
      }
    });

    console.log('Assignet cat: ', editAssignedCat);
    

    let count = 0;
    evaluationData.forEach((cri: any) => {

      count += Number(cri.porcentaje);
    });

    if (count < 100) {
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor agregue más criterios, hasta sumar 100 puntos",
        placement: "bottomRight",
      });
    }

    console.log("Index jurado: ", indexJurado);
    console.log("Edit completo: ", editValue);
    console.log("Edit con index: ", editValue[indexJurado]);
    
    
    if (editValue[indexJurado]) {
      const token = localStorage.getItem('token');
      let data = await axios.put(`${process.env.REACT_APP_SERVER_JURA2}criterios/actualizarCriterio/${editValue[indexJurado].id_jurado}`, { criterio: true }, 
      {
        headers: {
          "Authorization": token
        }
      });
      indexTabla = 0;
      return guardarCriterioTabla()
    }

    // setEditValue(fullarr);
    // setEditValueList(fullarr);
    // console.log('editValue: ', editValue);
    props.setIsModalVisible(false);
  }

  const guardarCriterioTabla: any = async () => {
    
    let nuevosCriterios = evaluationData.filter((x: any) => !x.id)


    if (nuevosCriterios[indexTabla]) {
      const token = localStorage.getItem('token');
      nuevosCriterios[indexTabla].jury_id = editValue[indexJurado].id_jurado;
      let proyectosAsignados: any = localStorage.proyectosAsignados
      proyectosAsignados = JSON.parse(proyectosAsignados);
      proyectosAsignados.forEach(async (p: any) => {
        
        let payload = nuevosCriterios[indexTabla];
        payload.postulacion_id = p.id_postulacion;
        let data = await axios.post(`${process.env.REACT_APP_SERVER_JURA2}criterios/crearCriterio/${editValue[indexJurado].id_jurado}`, nuevosCriterios[indexTabla], {
          headers: {
            "Authorization": token
          }
        });
      });

      indexTabla = indexTabla + 1;
      return guardarCriterioTabla();
    }

    indexJurado = indexJurado + 1;
    return handelListDataSubmit();

  }
  // function onEdit(upData: any) {
  //     const index = editValue.findIndex((item: any) => (item.idconvocatorias == editAssignedCat.idconvocatorias))
  //     const indexs = editValue[index].arrayData.findIndex((item: any) => (item.idconvocatorias == editFormData.idconvocatorias))
  //     editValue[index].arrayData[indexs] = upData
  //     // setEditForm(false)
  // }

  async function onEdit(upData: any) {
    
    // setEvaluationData(editAssignedCat.arrayData);
    // const index = editValue.findIndex((item: any) => item.idconvocatorias == editAssignedCat.idconvocatorias);
    // const indexs = editValue[index].arrayData.findIndex(
    //   (item: any) => item.idconvocatorias == editFormData.idconvocatorias
    // );
    // editValue[index].arrayData[indexs] = upData;
    if (upData.descripcion == '') {
      return openNotification({
        titulo: "Error",
        descripcion: "Falta la descripción",
        placement: "bottomRight",
      });
    }

    if (upData.nombre == '') {
      return openNotification({
        titulo: "Error",
        descripcion: "Falta el nombre",
        placement: "bottomRight",
      });
    }

    if (upData.porcentaje == '') {
      return openNotification({
        titulo: "Error",
        descripcion: "Falta el porcentaje",
        placement: "bottomRight",
      });
    }

    let arr = evaluationData.filter((x: any) => x.id !== upData.id);

    let existeYa = arr.find((x: any) => x.nombre === upData.nombre)

    if(existeYa){
      return openNotification({
        titulo: "Error",
        descripcion: "Ya existe ese criterio",
        placement: "bottomRight",
      });
    }

    let criterioSin = evaluationData.filter((x: any) => x.nombre !== upData.nombre);


    let suma = 0;
    criterioSin.forEach((x: any) => {
      suma += Number(x.porcentaje)
    });

    if (Number(upData.porcentaje) > suma) {
      
      return openNotification({
        titulo: "Error",
        descripcion: "Por favor verifique el puntaje de la evaluación, no superar 100 puntos",
        placement: "bottomRight",
      });
    }


    let evaluationDataNew = evaluationData.map((data: any) => {
      if (data.id === upData.id) {
        return {
          ...data,
          descripcion: upData.descripcion,
          nombre: upData.nombre,
          porcentaje: upData.porcentaje,
        };
      } else {

        return data

      }
    });
    setEvaluationData(evaluationDataNew)

    // console.log(upData);
    await apiJurados.actualizarCriterioJurado(upData);
    return setEditForm(false);
  }

  const handleCancel = () => {
    return  setEditForm(false);
  };

  return (
    <div>
      {editForm ? (
        <Modal
          className="transparent"
          visible={editForm}
          onCancel={handleCancel}
          footer={false}
          width={1000}
        >
          <EditFormEvaluacionCriteriosModel
            onEdit={onEdit}
            setEditForm={setEditForm}
            editFormData={editFormData}
            setEditFormData={setEditFormData}
            evaluationData={evaluationData}
          />
        </Modal>
      ) : (
        <div>
          <div className="" style={{ margin: 0, background: "white", padding: "20px", borderRadius: "15px" }}>
            <Content className="model__header asgevl_head">
              <Content className="mdl_header_containt">
                <Row
                  className="tbl_md_heading_box"
                  style={{
                    borderBottom: "1px solid #D7DBDD ",
                    paddingBottom: "6px",
                    marginBottom: "6px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Col span={10} className="">
                    <h3 className="asgevl_mdl_form_head">Criterios de evaluación </h3>
                  </Col>
                  {/* <Col span={10} className="text-right" style={{ display: "flex", justifyContent: "flex-end" }}>
                    <a className="mdl_close_btn" onClick={() => props.setIsModalVisible(false)}>
                      <CloseOutlined />
                    </a>
                  </Col> */}
                </Row>
              </Content>
            </Content>
            <Content className="asgevl__top_mdl_box">
              <Content className="">
                <Form>
                  <Row>
                    <Col span={24}>
                      <Content className="p-1">
                        <label className="form--lable asgevl_form_lable">Criterio de evaluación</label>
                        <Select
                          defaultValue="Seleccionar..."
                          style={{ width: "100%" }}
                          onChange={(e: any) =>
                            setEvaluationFormData({
                              ...evaluationFormData,
                              nombre: e,
                            })
                          }
                          className="eval--selct"
                          value={evaluationFormData.nombre}
                        >
                          {criterios.map(({ id, nombre }: any) =>
                            <Select.Option key={id} value={nombre}>{nombre}</Select.Option>
                          )}
                        </Select>
                      </Content>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 20, display: "flex", justifyContent: "space-between" }}>
                    <Col span={11}>
                      <Content className="p-1 ml-5">
                        <label className="form--lable asgevl_form_lable">Descripción</label>
                        <Input.TextArea
                          className="eval--textarea"
                          onChange={(e: any) =>
                            setEvaluationFormData({
                              ...evaluationFormData,
                              descripcion: e.target.value,
                            })
                          }
                          value={evaluationFormData.descripcion}
                        />
                        <Content
                          style={{ display: "flex", justifyContent: "flex-end", color: "orange", fontSize: "12px" }}
                        >
                          <p className="text-right">
                            <span className="textarea_txt_count">0/240</span>
                          </p>
                        </Content>
                      </Content>
                    </Col>
                    <Col span={11}>
                      <Content className="p-1">
                        <label className="form--lable asgevl_form_lable">Puntaje de evaluación</label>
                        <Input
                          // type="number"
                          onChange={(e: any) => {
                            // 
                            e.target.value = e.target.value.replace(/\D/, "")
                            setEvaluationFormData({
                              ...evaluationFormData,
                              porcentaje: e.target.value,
                            })
                          }}
                          className="eval-input evl_cat_input"
                          value={evaluationFormData.porcentaje}
                          maxLength={3}
                          min={0}
                          max={100}
                        />
                      </Content>
                    </Col>
                  </Row>
                </Form>
              </Content>
              <Content className="mb-2">
                <Row className="">
                  <Col span={24} className="form--btm-btn-box" style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      onClick={() => handelFormSubmit()}
                      className="button-blanco-radius"
                      style={{ cursor: "pointer" }}
                    >
                      Agregar
                    </Button>
                  </Col>
                </Row>
              </Content>
            </Content>
          </div>
          <div className="" style={{ marginTop: 12, background: "white", padding: "20px", borderRadius: "15px" }}>
            <Content style={{ background: "white" }}>
              <Content className="asgevl_table_box mt-1">
                <Content className="evalpro_table_head asgevl_tbl_head">
                  <Row>
                    <Col span={16}>
                      <span className="tbl__head eval_tbl_head">Lista de criterios a evaluar</span>
                    </Col>
                    <Col span={8}>
                      <p className="table--total table--total-mdl text-right">
                        Total : <span className="text-orance">{evaluationData.length}</span>
                      </p>
                    </Col>
                  </Row>
                </Content>

                <Content className="mb-1">
                  {
                    //@ts-ignore
                    <Table
                      columns={columnsEdit}
                      dataSource={evaluationData}
                      scroll={{ x: 800, y: 300 }}
                      size="small"
                      //rowClassName="sizeTable table-row"
                      className="table-ant-design-modify"
                      bordered={false}
                      pagination={false}
                      rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                    />
                  }
                </Content>

                <Content className="mb-2">
                  <Row className="">
                    <Col
                      span={24}
                      className="form--btm-btn-box form_clr_spn_btn"
                      style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                    >
                      {/* <span
                        onClick={() => props.setIsModalVisible(false)}
                        style={{ paddingRight: "5px", cursor: "pointer" }}
                      >
                        Cancelar
                      </span> */}
                      <Button className="button-gray-ghost"   onClick={() => handleCancel()}>
                        Cancelar
                      </Button>
                      <Button className="button-azul-radius" type="primary" onClick={() => handelListDataSubmit()}>
                        Asignar Criterios 
                      </Button>
                    </Col>
                  </Row>
                </Content>
              </Content>
            </Content>
          </div>
        </div>
      )}
    </div>
  );
}
